// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.details-item[data-v-6a95b158] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.details-item h4[data-v-6a95b158] {\n  padding: 0 1.15rem 0.85rem;\n  margin: 0;\n  color: var(--brand);\n}\n", ""]);
// Exports
module.exports = exports;
